import axios from 'axios';

// Tiempo maximo de espera del servicio de geolocalizacion.
// La ubicacion es un dato complementario: no debe retrasar el login.
const TIEMPO_ESPERA_UBICACION = 3000;

// Valor devuelto cuando el servicio de geolocalizacion no responde.
// La auditoria se registra igual, con los campos de ubicacion vacios.
const UBICACION_POR_DEFECTO = {
    countryCode: "",
    countryName: "",
    city: "",
    postal: "",
    state: "",
    latitude: 0,
    longitude: 0,
    ipv4: ""
};

// Copia de la ubicacion vacia, para usar como valor inicial en los consumidores.
export const ubicacionPorDefecto = () => ({ ...UBICACION_POR_DEFECTO });

export const obtenerUbicacionUsuario = async () => {

    try {
        const res = await axios.get('https://geolocation-db.com/json/', { timeout: TIEMPO_ESPERA_UBICACION });

        if (res === null || res === undefined || res.data === null || res.data === undefined) {
            return { ...UBICACION_POR_DEFECTO };
        }

        return {
            countryCode: res.data.country_code === null || res.data.country_code === undefined ? "" : res.data.country_code,
            countryName: res.data.country_name === null || res.data.country_name === undefined ? "" : res.data.country_name,
            city: res.data.city === null || res.data.city === undefined ? "" : res.data.city,
            postal: res.data.postal === null || res.data.postal === undefined ? "" : res.data.postal,
            state: res.data.state === null || res.data.state === undefined ? "" : res.data.state,
            latitude: res.data.latitude === null || res.data.latitude === undefined ? 0 : res.data.latitude,
            longitude: res.data.longitude === null || res.data.longitude === undefined ? 0 : res.data.longitude,
            ipv4: res.data.IPv4 === null || res.data.IPv4 === undefined ? "" : res.data.IPv4
        };

    } catch (e) {
        // El servicio de geolocalizacion es externo y puede fallar (caida, bloqueo
        // por adblocker/firewall, timeout). No debe impedir el registro de auditoria:
        // se devuelve la ubicacion vacia y el login se audita igual.
        return { ...UBICACION_POR_DEFECTO };
    }
}
